var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiRrPlusSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 11H13.5417V7C13.5417 6.73478 13.4319 6.48043 13.2366 6.29289C13.0412 6.10536 12.7763 6 12.5 6C12.2237 6 11.9588 6.10536 11.7634 6.29289C11.5681 6.48043 11.4583 6.73478 11.4583 7V11H7.29167C7.0154 11 6.75045 11.1054 6.5551 11.2929C6.35975 11.4804 6.25 11.7348 6.25 12C6.25 12.2652 6.35975 12.5196 6.5551 12.7071C6.75045 12.8946 7.0154 13 7.29167 13H11.4583V17C11.4583 17.2652 11.5681 17.5196 11.7634 17.7071C11.9588 17.8946 12.2237 18 12.5 18C12.7763 18 13.0412 17.8946 13.2366 17.7071C13.4319 17.5196 13.5417 17.2652 13.5417 17V13H17.7083C17.9846 13 18.2496 12.8946 18.4449 12.7071C18.6403 12.5196 18.75 12.2652 18.75 12C18.75 11.7348 18.6403 11.4804 18.4449 11.2929C18.2496 11.1054 17.9846 11 17.7083 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrPlusSmall);
export default __webpack_public_path__ + "static/media/fi-rr-plus-small.a8822ea9db461516dd52af8b7e2741ec.svg";
export { ForwardRef as ReactComponent };